import {VNode} from 'snabbdom/vnode';
import {Component, jsx} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {IronContextRegistry} from 'common/report/context-registry';
import {GdprLocalStorageManager} from 'common/contexts/local-storage-manager/gdpr';
import {WindowUrlManager} from 'common/contexts/url-manager/window';

interface JsxProps {
  attrs: EmptyObj;
}

// This is a blank, unstyled, non-shadow-DOM component designed only to wrap existing DOM structures so it can act as a Panel Context root for the DOM descendants under it.
// This context root is designed for standard user browser environments, not automated/isolated environements like WCT.
export class BrowserContextRoot extends Component<EmptyObj, JsxProps['attrs'], unknown, unknown, IronContextRegistry> {
  get config() {
    return {
      template: (): VNode => <div />,
      defaultContexts: {
        localStorageManager: new GdprLocalStorageManager(),
        urlManager: new WindowUrlManager(),
      },
    };
  }
}

export const BrowserContextRootEl = defineAndMakeJsxFactory<JsxProps>(`mp-browser-context-root`, BrowserContextRoot);
